$(document).ready(function () {
    $(".carousel").slick({
        infinite: true,
        dots: true,
        appendDots: $(".testimonials-carousel-nav"),
        dotsClass: "testimonials-carousel-nav-list",
        centerMode: false,
        initialSlide: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
});

// Scroll
const anchors = [].slice.call(document.querySelectorAll('a[href*="#"]')),
    animationTime = 500,
    framesCount = 40;

anchors.forEach(function (item) {
    item.addEventListener("click", function (e) {
        if (item.href.indexOf('#how-we-work') ===-1) {
            e.preventDefault();
            console.log(item.href);
            let coordY = document.querySelector(item.getAttribute("href")).getBoundingClientRect().top + window.pageYOffset;

            let scroller = setInterval(function () {
                let scrollBy = coordY / framesCount;

                if (
                    scrollBy > window.pageYOffset - coordY &&
                    window.innerHeight + window.pageYOffset < document.body.offsetHeight
                ) {
                    window.scrollBy(0, scrollBy);
                } else {
                    window.scrollTo(0, coordY);
                    clearInterval(scroller);
                }
            }, animationTime / framesCount);
        }
    });
});
